import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getThreadById = {
  name: "getThreadById" as const,
  input: z.object({ threadId: zExt.objectId() }),
  output: z
    .object({
      _id: zExt.objectId(),
      agentName: z.string(),
      team: zExt.objectId(),
      parentThreadId: zExt.objectId().nullish(),
      prompt: z.string(),
      messages: z.array(MessageSchema),
      pendingTools: z.array(
        z.object({
          id: z.string(),
          toolName: z.string(),
          args: z.json(),
          confirmed: createEnum([
            "confirmed",
            "pending",
            "not_required",
          ]).nullish(),
          confirmationData: z.json().nullish(),
          confirmationPrompt: z.string().nullish(),
        }),
      ),
      state: z.json(),
      output: z.json().optional(),
      iterationCount: z.number(),
      createdAt: z.date(),
      updatedAt: z.date(),
      intercomConversationId: z.string().nullish(),
    })
    .nullish(),
};
